import {BasePage} from '../utils/base';
import {Element} from '../utils/element';
import '../css/messages.scss';
import {send} from 'q';

export class Messages extends BasePage {
  chatInfo;
  chats;

  container;
  view;

  messages = [];
  files = {};
  filesToMessage = {};

  nextWaiting = 0;
  waitingList = [];
  blockedBy;

  limit = false;
  inited = false;
  closed = false;
  blocked = false;

  group;

  constructor(chatInfo, chats) {
    super();

    this.chatInfo = chatInfo;
    this.chats = chats;

    (async () => {
      if (this.chatInfo.type['@type'] === 'chatTypeSupergroup') {
        this.group = await this.apiHelper.getSupergroupFullInfo(this.chatInfo.type.supergroup_id);
      }
      this.initView();
      await this.openChat();
      this.getMessages();

      let el = document.querySelector('.messages-history-wrapper');
    })();
  }

  initView() {
    this.container = new Element('.app .messages-container');
    this.container.html = '';

    this.container.ch(new Element('.templates .messages').el.cloneNode(true));
    this.container.ac('open');

    this.view = new Element('.messages', this.container.el);
    if (this.apiHelper.userId === this.chatInfo.id) {
      this.view.ac('savedMessages');
    }

    this.addLoading('.messages-loading', this.view.el);

    this.renderUserPic();
    this.renderTitle();
    this.renderOnline();
    this.renderClose();

    this.apiHelper.subscribers.push(this.subscribeApi);
  }

  openChat = async () => {
    await this.apiHelper.openChat(this.chatInfo.id);
  };

  closeChat = async () => {
    this.closed = true;
    await this.apiHelper.closeChat(this.chatInfo.id);
  };

  getMessages(startFrom?) {
    if (this.limit) {
      return;
    }

    this.apiHelper.getMessages(this.chatInfo.id, startFrom).then(res => {
      this.messages.push(...res.messages);

      if (!res.messages.length) {
        this.view.rc('loading');
        this.limit = true;
        this.inited = true;

        this.renderMessages();
      }

      if (this.messages.length < 100) {
        this.getMessages(this.messages[this.messages.length - 1].id);
      } else {
        this.view.rc('loading');
        this.inited = true;

        this.renderMessages();
      }

      // console.log(res.messages);
    });
  }

  renderUserPic() {
    let fileUrl;
    let chatInfo = this.chatInfo;
    let picEl = new Element('.messages-pic');

    if (chatInfo.photo) {
      fileUrl = this.chats.getFilePic(chatInfo);
    }

    if (fileUrl) {
      if (fileUrl !== picEl.ga('url')) {
        let newPic = `<img src="${fileUrl}" />`;

        picEl.sa('url', fileUrl);
        picEl.html = newPic;
        picEl.ac('img');
      }
    } else {
      let titleArr = chatInfo.title.split(' ');
      let picText = 'DEL';

      if (chatInfo.title) {
        picText = titleArr[0][0] + (titleArr.length > 1 ? titleArr[titleArr.length - 1][0] : '');
      }
      picEl.html = `<span>${picText}</span>`;
    }
  }

  renderTitle() {
    let titleEl = new Element('.messages-name');
    if (this.apiHelper.userId === this.chatInfo.id) {
      titleEl.html = 'Saved Messages';
    } else {
      titleEl.html = this.chatInfo.title;
    }
  }

  renderOnline() {
    let onlineEl = new Element('.messages-online');
    let isOnline = this.chats.getIsOnline(this.chatInfo);

    if (this.apiHelper.userId == this.chatInfo.id) {
      onlineEl.html = 'Always here for you! ❤';
    } else if (isOnline) {
      onlineEl.ac('online');
      onlineEl.html = 'online';
    } else if (this.group) {
      onlineEl.html = `${this.group.member_count} subscribes`;
    } else {
      onlineEl.rc('online');
      onlineEl.html = 'offline';
    }
  }

  renderClose() {
    let closeEl = new Element('.messages-close');
    closeEl.click = () => {
      this.container.html = '';
      this.container.rc('open');

      this.closeChat();
    };
  }

  renderMessages() {
    let historyEl = new Element('.messages-history');
    this.messages.reverse().forEach(message => {
      let messageEl = new Element(`[messageid="${message.id}"] .message-element`);
      if (!messageEl.el) {
        let messageWrapperEl = new Element().div();
        messageWrapperEl.sa('messageid', message.id);
        messageWrapperEl.ac('message-element-wrapper');

        messageEl = new Element().div();
        messageEl.ac('message-element');

        messageWrapperEl.ch(messageEl.el);

        if (this.group) {
          messageEl.ac('group');
        }

        historyEl.ch(messageWrapperEl.el);
      }

      this.renderMessage(message.id, message, messageEl);
    });
  }

  renderText(messageId, message, messageEl) {
    messageEl.ac('text');
    messageEl.html = message.content.text.text;
  }

  renderSticker(messageId, message, messageEl) {
    let content = message.content;
    let stiker = content.sticker.sticker;
    let isAnimated = content.sticker.is_animated;

    messageEl.ac('sticker');

    let fileUrl = this.getFile(stiker, message);
    if (fileUrl) {
      if (isAnimated) {
        let stikerEl = new Element().tgs();
        stikerEl.src = fileUrl;

        stikerEl.sa('autoplay', 'true');
        stikerEl.sa('loop', 'true');

        messageEl.html = '';
        messageEl.ch(stikerEl.el);
        return;
      } else {
        messageEl.html = `<img src=${fileUrl} />`;
      }
    } else {
      messageEl.html = 'loading...';
    }
  }

  renderImage(messageId, message, messageEl) {
    let content = message.content;
    let photo = content.photo.sizes[0].photo;

    let width = content.photo.sizes[0].width;
    let height = content.photo.sizes[0].height;

    if (content.photo.sizes[1]) {
      photo = content.photo.sizes[1].photo;
    }

    let fileUrl = this.getFile(photo, message);

    messageEl.ac('photo');
    if (width > height) {
      messageEl.ac('hor');
    }

    if (fileUrl) {
      messageEl.html = `<img src=${fileUrl} />`;
    } else {
      messageEl.html = 'loading...';
    }
  }

  renderMessage(messageId, message?, messageEl?) {
    if (!message) {
      message = this.messages.filter(message => message.id == messageId)[0];
    }

    if (!messageEl || !messageEl.el) {
      messageEl = new Element(`[messageid="${messageId}"] .message-element`);
    }

    if (!message || !messageEl || !messageEl.el) {
      return;
    }

    let content = message.content;
    let sender = message.sender_user_id;

    if (sender === this.apiHelper.userId) {
      messageEl.el.parentElement.classList.add('me');
      messageEl.ac('me');
    }

    let html;
    if (content['@type'] === 'messageText') {
      this.renderText(messageId, message, messageEl);
      return;
    } else if (content['@type'] === 'messageSticker') {
      this.renderSticker(messageId, message, messageEl);
      return;
    } else if (content['@type'] === 'messagePhoto') {
      this.renderImage(messageId, message, messageEl);
      return;
    } else if (content['@type'] === 'messageVideoNote') {
      let thumb = content.video_note.thumbnail.photo;
      let fileUrl = this.getFile(thumb, message);
      messageEl.ac('video-note');
      if (fileUrl) {
        messageEl.ac('loaded');
        html = `<img src=${fileUrl} />`;
      } else {
        html = 'loading...';
      }
    } else if (content['@type'] === 'messageVideo') {
      let thumb = content.video.thumbnail.photo;
      let fileUrl = this.getFile(thumb, message);
      messageEl.ac('video');
      if (fileUrl) {
        messageEl.ac('loaded');
        html = `<img src=${fileUrl} />`;
      } else {
        html = 'loading...';
      }
    } else if (content['@type'] === 'messageVoiceNote') {
      messageEl.ac('text');
      html = `Voice Note`;
    } else if (content['@type'] === 'messageChatChangeTitle') {
      messageEl.ac('some');
      messageEl.el.parentElement.classList.add('some');
      html = `Chat Title was changed to ${content.title}`;
    } else if (content['@type'] === 'messageChatChangePhoto') {
      messageEl.ac('some');
      messageEl.el.parentElement.classList.add('some');
      html = 'Chat photo was changed';
    } else if (content['@type'] === 'messageSupergroupChatCreate') {
      messageEl.ac('some');
      messageEl.el.parentElement.classList.add('some');
      html = 'Group was created';
    } else if (content['@type'] === 'messageDocument') {
      messageEl.ac('text');
      html = `Document`;
    } else if (content['@type'] === 'messagePinMessage') {
      messageEl.ac('text');
      html = 'Pin Message';
    } else if (content['@type'] === 'messageAnimation') {
      messageEl.ac('text');
      html = `Animation`;
    } else if (content['@type'] === 'messageLocation') {
      messageEl.ac('text');
      html = `Location`;
    } else if (content['@type'] === 'messageChatJoinByLink') {
      messageEl.ac('some');
      messageEl.el.parentElement.classList.add('some');
      html = 'User joined group';
    } else if (content['@type'] === 'messagePoll') {
      messageEl.ac('text');
      html = `Poll`;
    }

    messageEl.html = html;
  }

  getFile(file, message) {
    let fileId = file.id;
    let messageId = message.id;

    if (!this.filesToMessage[fileId]) {
      this.filesToMessage[fileId] = [messageId];
    } else {
      this.filesToMessage[fileId].push(messageId);
    }

    let isBlob = this.files[fileId] && this.files[fileId].indexOf('blob') !== -1;
    if (isBlob) {
      return this.files[fileId];
    }

    // if (this.blockedBy !== fileId && this.blocked) {
    //   if (this.waitingList.indexOf(file.id) === -1) {
    //     this.waitingList.push(file.id);
    //   }
    //   return null;
    // }

    this.blockedBy = fileId;
    this.blocked = true;

    if (!this.files[fileId]) {
      this.files[fileId] = 'download';
      this.apiHelper
        .downloadFile(fileId)
        .then(() => {
          this.files[fileId] = 'pending';
        })
        .catch(() => (this.files[fileId] = 'error'));
    } else if (this.files[fileId] === 'success') {
      this.apiHelper.getFile(fileId).then(file => {
        this.blocked = false;

        // if (this.nextWaiting < this.waitingList.length) {
        //   new Promise(() => {
        //     let nextFileId = this.waitingList[this.nextWaiting];
        //     let nextMessageId = this.filesToMessage[nextFileId][0];
        //     this.nextWaiting++;

        //     this.renderMessage(nextMessageId);
        //   });
        // }

        this.files[fileId] = window.URL.createObjectURL(file.data);

        let messageIds = this.filesToMessage[fileId];
        messageIds.forEach(messageId => {
          this.renderMessage(messageId);
        });
      });
    }

    return null;
  }

  subscribeApi = res => {
    if (this.closed) {
      return;
    }

    if (res['@type'] === 'updateFile') {
      let fileId = res.file.id;

      if (this.files[fileId] === 'pending' && res.file.expected_size === res.file.local.downloaded_size) {
        this.files[fileId] = 'success';

        let messageId = this.filesToMessage[fileId][0];
        this.renderMessage(messageId);
      }
    }
  };
}
